import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import races from '../../config/races';

const Race = props => {
  const [actualRace, setActualRace] = React.useState(undefined);
  const { raceId } = props.match.params;

  useEffect(() => {
    if (raceId) {
      setActualRace(races.filter(race => race.id === parseInt(raceId))[0]);
    }
  }, [raceId]);

  if (actualRace) {
    return (
      <>
        <h2>{actualRace.title}</h2>
        <p>{actualRace.date}</p>
        <p>{actualRace.shortDescription}</p>
      </>
    );
  }

  return <p>You need a raceId</p>;
};

export default withRouter(Race);
